// extracted by mini-css-extract-plugin
module.exports = {"logo_pointer":"Logo_logo_pointer__3tyo_"};